import Vue from 'vue'
import Router from 'vue-router'

const Index = () =>
    import ('../pages/index')
const PeopleManager = () =>
    import ('../pages/peoplemanager')
const CarManager = () =>
    import ('../pages/carmanager')
const PZManager = () =>
    import ('../pages/pzmanager')
const TXManager = () =>
    import ('../pages/txmanager')
const QZManager = () =>
    import ('../pages/qzmanager')
const Login = () =>
    import ('../pages/login')	
Vue.use(Router)

const router = new Router({
    routes: [{
            path: '',
            redirect: '/login'
			
        },
		{
		    path: '/login',
		    component: Login
		},
        {
            path: '/index',
            component: Index
        },
        {
            path: '/peoplemanager',
            component: PeopleManager
        },
        {
            path: '/carmanager',
            component: CarManager
        },
        {
            path: '/pzmanager',
            component: PZManager
        },
        {
            path: '/txmanager',
            component: TXManager
        },
        {
            path: '/qzmanager',
			name:'qzmanager',
            component: QZManager
        }
    ],
    // mode: 'history'
})

export default router